/* eslint-env browser */
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import PageLayout from '../PageLayout';
import { ExternalLink as ExternalLinkBase } from '../ExternalLink/ExternalLink';

import { mediaPhone, minTablet } from '../styles/breakpoints';
import { ImpressumTextColor } from '../styles/colors';
import { MonospaceFont } from '../styles/fonts';

import CloseImpressumIconImg from './icons/outline-highlight_off-24px.svg';

const Section = styled.section`
  color: ${ImpressumTextColor};
`;

const InnerContent = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};

  margin-left: 20px;
  margin-right: 20px;

  ${minTablet} {
    width: 645px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const H4 = styled.h4`
  font-size: inherit;
  font-weight: bold;
  color: ${ImpressumTextColor};
`;

const Hr = styled.hr`
  border: none;
  height: 1px;
  color: ${ImpressumTextColor};
  background-color: ${ImpressumTextColor};
  margin: 2.5em 0;
`;

const ImpressumHeader = styled.div`
  line-height: 3;

  text-align: right;

  ${mediaPhone} {
    font-size: 12px;
  }
`;

const ArticleImpressum = styled.article`
  font-size: 15px;
  ${mediaPhone} {
    font-size: 12px;
  }
  margin-bottom: 30px;
`;

const Haftungsausschluss = styled.div`
  font-size: 13px;
  ${mediaPhone} {
    font-size: 12px;
  }
`;

const ResetButtonStyles = css`
  -webkit-appearance: none;
  border: none;
  background-color: transparent;

  cursor: pointer;

  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }
`;

const Button = styled.button([
  ResetButtonStyles,
  `

  font-size: 15px;
  ${mediaPhone} {
    font-size: 12px;
  }

  color: ${ImpressumTextColor};
`]);

const CloseImpressumButton = styled.button([
  ResetButtonStyles,
  MonospaceFont,
  `
  font-size: 15px;
  ${mediaPhone} {
    font-size: 12px;
  }

  color: #000;

  opacity: .5;
  &:hover {
    opacity: .9;
  }

  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: 30px;
  line-height: 24px;

  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: left;
  background-image: url(${CloseImpressumIconImg});
`]);

const H4Styled = styled(H4)`
  margin-bottom: 0;
`;

const ExternalLink = styled(ExternalLinkBase)`
  color: ${ImpressumTextColor} !important;
  text-decoration: none;
`;

class Impressum extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
    };
  }

  showImpressum() {
    this.setState({ isOpen: true });
    setTimeout(() => {
      document.getElementById('impressum').scrollIntoView();
    }, 50);
  }

  closeImpressum() {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;

    return (
      <Section>
        <PageLayout>
          <ImpressumHeader>
            <Button onClick={() => this.showImpressum()}>
              Impressum, Kontakt und Haftungsausschluss
            </Button>
            <p>
              <ExternalLink href="http://www.bundfuerbildung.de">
                &copy; Bund für Bildung e. V.
              </ExternalLink>
            </p>
          </ImpressumHeader>
        </PageLayout>
        <InnerContent isOpen={isOpen}>
          <ArticleImpressum id="impressum">
            <p>
              Inhaltlich Verantwortlicher gem&auml;&szlig; § 10 Absatz 3 MDStV
              <br />
              <ExternalLink href="http://www.bundfuerbildung.de">
                Bund f&uuml;r Bildung e. V.
              </ExternalLink>
              <br />
              Alle Rechte vorbehalten
            </p>

            <H4Styled>
              Verantwortlich f&uuml;r die Erstellung der Unterrichtsmaterialien und der Website:
            </H4Styled>
            <p>
              Konzept und Redaktion: Claudia Wegener, Dr. Ulrike Wunderle
              <br />
              Fachberater: Falko Stolp
              <br />
              Grafische Umsetzung: Stefan Hoch, Kira Freese (Unterrichtsmaterialien und Website)
              <br />
              Lektorat: Sabine Hatzfeld
              <br />
              Programmierung und Hosting: <ExternalLink href="https://www.spearwolf.de">Wolfger Schramm (spearwolf)</ExternalLink>
            </p>

            <Hr />

            <Haftungsausschluss>
              <H4>
                Haftungsausschluss
              </H4>
              <p>
                1. Inhalt des Onlineangebotes: Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
              </p>
              <p>
                2. Verweise und Links: Bei direkten oder indirekten Verweisen auf fremde Webseiten („Hyperlinks“), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
              </p>
              <p>
                3. Urheber und Kennzeichenrecht: Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
              </p>
              <p>
                4. Datenschutz: Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – soweit technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie Emailadressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstössen gegen dieses Verbot sind ausdrücklich vorbehalten.
              </p>
              <p>
                5. Rechtswirksamkeit dieses Haftungsausschlusses: Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
              </p>
            </Haftungsausschluss>
          </ArticleImpressum>
          <CloseImpressumButton onClick={() => this.closeImpressum()}>Verbergen</CloseImpressumButton>
        </InnerContent>
      </Section>
    );
  }
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/components/Impressum/Impressum.js